export default "__VITE_ASSET__fbe80454__"